export const WIDTH = "825px";

export const TABS = {
  PORTALS: "portals",
  PAGES: "pages",
  // LAYOUTS: "layouts",
  ALERTS: "alerts",
  CONTENT: "content"
};
